import Vue from "vue";
import Router from "vue-router";
import LoginPage from "./views/LoginPage.vue";
import LandingPage from "./views/LandingPage.vue";
import MainApp from "./views/MainApp.vue";
import HubHeader from "./layout/HubHeader.vue";
import HubFooter from "./layout/HubFooter.vue";
Vue.use(Router);

let router = new Router({
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "Login",
      components: {
        header: HubHeader,
        default: LoginPage,
        footer: HubFooter
      }
    },
    {
      path: "/landingPage",
      name: "LandingPage",
      components: {
        header: HubHeader,
        default: LandingPage,
        footer: HubFooter
      }
    },
    {
      path: "/MainApp",
      name: "MainApp",
      components: {
        header: HubHeader,
        default: MainApp,
        footer: ""
      },
      props: {
        activeTab: true
      }
    },
  ]
});
// router.beforeResolve((to, from, next) => {
//   var isLoggedIn = (typeof(sessionStorage.accessToken)=="undefined")||sessionStorage.accessToken==""?false:true
//   if (!isLoggedIn && to.path != "/login") {
//     next("/login")
//   }
//   else if (isLoggedIn && to.path == "/") {
//     if (from.path == "/") {
//       next("LandingPage")
//     }
//     else {
//       next(from.path)
//     }
//   }
//   else if (to.path == "/login" && isLoggedIn) {
//     next("/LandingPage")
//   }
//   else {
//     next()
//   }
// })
export default router;
